import React, { useEffect, useRef } from "react";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { getAllWebcareerscityAsync, WebcareerscityActions } from "../redux";
import WebcareerscityTable from "./webcareerscityDetail/webcareerscityTable";
import {
  Card,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import { useIsAccessAllow } from "../../users/redux";

export function WebCareersCity() {
  const dispatch = useDispatch();
  const history = useHistory();
  const searchRef = useRef();
  const { refreshWebcareerscity, searchBy, searchText } = useSelector(
    (state) => state.webcluescareerscity,
    shallowEqual
  );

  useEffect(() => {
    if (searchRef.current) {
      let keyPressEvent = (e) => {
        if (e.keyCode === 13) {
          e.preventDefault();
          dispatch(WebcareerscityActions.refreshWebcareerscityList());
        }
      };
      let input = searchRef.current;
      input.addEventListener("keyup", keyPressEvent);

      return () => {
        input.removeEventListener("keyup", keyPressEvent);
        dispatch(WebcareerscityActions.searchTextChange(""));
        input.value = "";
      };
    }
  }, [dispatch]);

  useEffect(() => {
    if (refreshWebcareerscity) {
      dispatch(getAllWebcareerscityAsync(searchBy, searchText));
    }
    // eslint-disable-next-line
  }, [refreshWebcareerscity]);

  const onSearchTextChange = (e) => {
    dispatch(WebcareerscityActions.searchTextChange(e.target.value));
  };

  const onSelectWebcareerscity = (webcareerscity) => {
    history.push(`/web_careers_city/add-webcareerscity`);
  };
  const isAddWebcareerscityAllow = useIsAccessAllow(
    "webcareerscity.add_webcareerscity"
  );
  const isSearchAllow = useIsAccessAllow("webcareerscity.list");

  return (
    <>
      <Card>
        <CardHeader title="Web Careers City">
          <CardHeaderToolbar>
            <div className="d-flex flex-wrap ap_filter_wraper justify-content-end align-items-center">
              <form
                className="subheader_filter"
                onSubmit={(e) => e.preventDefault()}
              >
                <div className="form-row">
                  {isAddWebcareerscityAllow && (
                    <div className="form-group mr-5 mb-1 mt-2">
                      <button
                        className="btn_new btn-sm"
                        type="button"
                        onClick={() => onSelectWebcareerscity()}
                      >
                        Add
                      </button>
                    </div>
                  )}
                  {isSearchAllow && (
                    <div className="form-group mr-3 mb-1">
                      <input
                        name="Search"
                        placeholder="Search. . ."
                        type="text"
                        className="form-control"
                        value={searchText}
                        autoComplete="off"
                        onChange={onSearchTextChange}
                        ref={searchRef}
                      />
                    </div>
                  )}
                </div>
              </form>
            </div>
          </CardHeaderToolbar>
        </CardHeader>
        <WebcareerscityTable />
      </Card>
    </>
  );
}
